class StatusAutoInfracaoTransito {
    constructor(
        {
            id = null,
            codigo_status = null,
            descricao = null,
            created_at = null,
            updated_at = null,
            deleted_at = null,
            usuario_id = null,
            ind_status_bhtrans = null,
            ind_status_terceiros = null,
        } = {}
    ) {
        this.id = id;
        this.codigo_status = codigo_status;
        this.descricao = descricao;
        this.created_at = created_at;
        this.updated_at = updated_at;
        this.deleted_at = deleted_at;
        this.usuario_id = usuario_id;
        this.ind_status_bhtrans = ind_status_bhtrans;
        this.ind_status_terceiros = ind_status_terceiros;
    }

    isCancelado(){   return parseInt(this.codigo_status) ==  9    }
    

}

export default StatusAutoInfracaoTransito;